import { useCallback } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { RootState } from "store";
import {
  storeCustomerRequested,
  updateCustomerRequested,
  updateBlockStatusRequested,
} from "store/customers/customersSlice";

export function useStoreCustomer() {
  const dispatch = useDispatch();

  const onStoreCustomer = useCallback(
    async (values: any, actions: any) => {
      actions.setSubmitting(true);
      let data = {
        ...values,
        roundId: values?.roundId?.id,
        deliveryChargeId: values?.delivery?.id,
      };

      await dispatch(storeCustomerRequested(data));

      setTimeout(() => {
        actions.setSubmitting(false);
      }, 1000);
    },
    [dispatch]
  );
  return { onStoreCustomer };
}

export function useUpdateCustomer() {
  const dispatch = useDispatch();
  const { page, perPage } = useSelector((state: RootState) => state.state);
  const onUpdateCustomer = useCallback(
    async (values: any) => {
      values.roundId = values.roundId.id;
      values.deliveryChargeId = values?.delivery?.id;
      values.page = page;
      values.perPage = perPage;
      await dispatch(updateCustomerRequested(values));
    },
    [dispatch]
  );
  return { onUpdateCustomer };
}

export function useUpdateBlockStatus() {
  const dispatch = useDispatch();

  const onUpdateBlockStatus = useCallback(
    async (values: any) => {
      await dispatch(
        updateBlockStatusRequested({ reference: values?.reference })
      );
    },

    [dispatch]
  );
  return { onUpdateBlockStatus };
}
